import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Modal, Button, Spinner, Form } from "react-bootstrap";
import fetchHook from "../../hooks/fetchMSSQL-hook";

const EvadtsCompareModal = ({ show, onHide, visitId, machineId, currentData, onCompared }) => {
  const { fetchMssqlApi } = fetchHook();
  const [list, setList] = useState([]);
  const [selected, setSelected] = useState("");
  const [loading, setLoading] = useState(false);

useEffect(() => {
  if (!show || !machineId) return;
  setSelected("");
  setList([]);
  let cancelled = false;

  fetchMssqlApi(
    "kp/evadts/last",
    { params: { machineId, visitId }, showLoader: false },
    (res) => {
      if (!cancelled) setList(Array.isArray(res) ? res : []);
    },
    (err) => {
      console.error("Fetch error:", err);
      if (!cancelled) setList([]);
    }
  );

  return () => {
    cancelled = true;
  };
}, [show, machineId]);

  const selectedItem = useMemo(
    () => list.find((x) => String(x.MachineCoinInventoryId) === String(selected)) || null,
    [list, selected]
  );

  const handleCompare = () => {
    if (!selectedItem || !visitId || loading) return;
    setLoading(true);

    fetchMssqlApi(
      "kp/evadts/compare",
      { params: { visitId, machineCoinInventoryId: selectedItem.MachineCoinInventoryId }, showLoader: false },
      (res) => {
        const rows = Array.isArray(res) ? res : [];
        setLoading(false);
        onHide && onHide();

        const right = {
          MachineCoinInventoryId: selectedItem.MachineCoinInventoryId,
          FullName: selectedItem.FullName || "",
          CreateDateTimeStr: selectedItem.CreateDateTimeStr || "",
          UserName: selectedItem.UserName || "",
        };

        onCompared && onCompared({
          rows,
          headerLeft: currentData || null,
          headerRight: right,
        });
      },
      (err) => {
        console.error("COMPARE ERROR:", err);
        setLoading(false);
      }
    );
  };

  return (
    <Modal show={show} onHide={onHide} centered size="lg" backdrop="static" keyboard={false} restoreFocus={false}>
      <Modal.Header closeButton>
        <Modal.Title>Porównanie danych EVADTS</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
        <div className="d-flex mb-3 align-items-center">
          <Form.Control
            as="select"
            className="mr-2"
            value={selected}
            onChange={(e) => setSelected(e.target.value)}
          >
            <option value="">Wybierz EVADTS</option>
            {list.map((x) => (
              <option key={x.MachineCoinInventoryId} value={String(x.MachineCoinInventoryId)}>
                ({x.FullName}) {x.CreateDateTimeStr || x.CreateDateTime} – {x.UserName || "Nieznany użytkownik"}
              </option>
            ))}
          </Form.Control>

          <Button variant="primary" onClick={handleCompare} disabled={!selected || loading}>
            {loading ? (
              <>
                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" className="mr-2" />
                Porównywanie...
              </>
            ) : (
              "Porównaj"
            )}
          </Button>
        </div>

        <p className="text-muted mb-0">
          Wybierz EVADTS z listy i kliknij <b className="text-dark">Porównaj</b>
        </p>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Zamknij
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EvadtsCompareModal;